module.exports = __webpack_public_path__ + "img/back-icon.dbd46a8e.svg";